import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button, Text, useDisclosure } from '@chakra-ui/react';
import { SystemTranslationKeys } from '@common/entities';

import { useSystemTranslation } from 'hooks';
import { requestSdkExternalRedirect } from 'utils/sdkClose';
import {
  buildProspectPortalPrivacyNoticeUrl,
  resolveEntrataRedirectLink,
  resolvePrivacyNoticeUrl,
} from 'utils/viewerLaunchContextSession';

import TermsOfUse from './TermsOfUse';

const AuthConsentNotice = () => {
  const { t, tSystem } = useSystemTranslation();
  const { isOpen: isTermsOpen, onOpen: onTermsOpen, onClose: onTermsClose } = useDisclosure();
  const [searchParams] = useSearchParams();

  const prospectPortalOrigin = resolveEntrataRedirectLink(searchParams);
  const configuredPrivacyNoticeUrl = resolvePrivacyNoticeUrl(searchParams.get('privacyNoticeUrl'));
  const privacyNoticeUrl =
    configuredPrivacyNoticeUrl ?? buildProspectPortalPrivacyNoticeUrl(prospectPortalOrigin);

  const handlePrivacyNoticeClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!configuredPrivacyNoticeUrl || window.parent === window) return;

    event.preventDefault();
    requestSdkExternalRedirect(configuredPrivacyNoticeUrl);
  };

  return (
    <>
      <Text fontSize="sm">
        {t('auth.createAccountConsentPrefix', 'By creating an account, I agree to the')}{' '}
        <Button variant="link" size="sm" h="auto" minW="auto" p={0} onClick={onTermsOpen}>
          {tSystem(SystemTranslationKeys.common.termsOfUse)}
        </Button>{' '}
        {t('auth.createAccountConsentMiddle', 'and acknowledge I have read the')}{' '}
        {privacyNoticeUrl ? (
          <Button
            as="a"
            variant="link"
            size="sm"
            h="auto"
            minW="auto"
            p={0}
            href={privacyNoticeUrl}
            onClick={handlePrivacyNoticeClick}
          >
            {t('auth.createAccountPrivacyNotice', 'Privacy Notice')}
          </Button>
        ) : (
          t('auth.createAccountPrivacyNotice', 'Privacy Notice')
        )}
        .
      </Text>
      <TermsOfUse isOpen={isTermsOpen} onClose={onTermsClose} />
    </>
  );
};

export default AuthConsentNotice;
